import { render, staticRenderFns } from "./PoiForm.vue?vue&type=template&id=4f6855ba&scoped=true&"
import script from "./PoiForm.vue?vue&type=script&lang=js&"
export * from "./PoiForm.vue?vue&type=script&lang=js&"
import style0 from "./PoiForm.vue?vue&type=style&index=0&id=4f6855ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6855ba",
  null
  
)

export default component.exports